import { FilterType } from "@domain/enums/FilterType";
import { FilterMapper } from "@app/routing/mappers/FilterMapper";
import { AttendanceFilterValue } from "@studyportals/search-api-interface";
import {IExtendedWithPortalTypeFilterValue} from "@app/routing/mappers/IExtendedWithPortalTypeFilterValue";

export class AttendanceFilterMapper extends FilterMapper {
	public filterType: FilterType = FilterType.ATTENDANCE;
	public isMultiSelect = true;
	private static instance: AttendanceFilterMapper;

	public static getInstance(): AttendanceFilterMapper {
		if (!AttendanceFilterMapper.instance) {
			AttendanceFilterMapper.instance = new AttendanceFilterMapper();
		}
		return AttendanceFilterMapper.instance;
	}

	private constructor() {
		super();
	}

	protected values: IExtendedWithPortalTypeFilterValue[] = [
		{ id: AttendanceFilterValue.FACE_2_FACE, virtualPath: 'on-campus', name: 'On Campus' },
		{ id: AttendanceFilterValue.ONLINE, virtualPath: 'online', name: 'Online' },
		{ id: AttendanceFilterValue.BLENDED, virtualPath: 'blended', name: 'Blended' },
	];
}

